import React, { useEffect } from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import ForcePasswordChange from './ForcePasswordChange';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, fetchUser, user } = useAuthStore();
  const { tenantSlug } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      fetchUser();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    // Redirect to the tenant's login if we know the slug (from `/t/<slug>/*`),
    // otherwise send them to the marketing landing where the subdomain modal
    // will let them enter one.
    if (tenantSlug) {
      return <Navigate to={`/t/${tenantSlug}/login`} state={{ from: location }} replace />;
    }
    return <Navigate to="/" replace />;
  }

  if (user?.must_change_password && !user?.impersonated_by) return <ForcePasswordChange />;

  return children;
};

export default ProtectedRoute;
